import React from 'react';

const e = React.createElement;

export default function NotFound() {
  return e('section', { className: 'not-found-section' },
    e('div', { className: 'not-found-container' },
      e('div', { className: 'not-found-content' },
        e('div', { className: 'not-found-badge' },
          e('i', { className: 'fa-solid fa-triangle-exclamation' }),
          ' Error 404'
        ),
        e('h1', { className: 'not-found-heading' },
          '404 - Page ',
          e('span', { className: 'text-highlight-green' }, 'Not Found')
        ),
        e('p', { className: 'not-found-lead' },
          'Oops! The page you are looking for doesn\'t exist, has been moved, or is temporarily unavailable.'
        ),
        e('div', { className: 'not-found-ctas' },
          e('a', { href: '/', className: 'btn btn-primary btn-large' },
            e('i', { className: 'fa-solid fa-house' }),
            ' Return to Home'
          ),
          e('a', { href: '/services', className: 'btn btn-secondary btn-large' },
            'Explore Services'
          ),
          e('a', { href: '/contact', className: 'btn btn-secondary btn-large' },
            'Contact Support'
          )
        )
      )
    )
  );
}
